export const fr = {
  "alert": {
    "no_assignment_theory_found": "Il n’y a pas de théorie disponible."
  },
  "arrangement": {
    "assignments": {
      "button_title_next": "Exercice suivant",
      "button_title_previous": "Dernier exercice",
      "collapse": "Masquer les résultats",
      "complete": {
        "submit": "Terminer",
        "submit_text": "Tous les exercices sont terminés. Soumets ton auto-test pour voir tes résultats."
      },
      "expand": "Afficher les résultats",
      "legend": {
        "answer_send": "La réponse a été soumise",
        "draft": "La réponse n'est pas encore terminée",
        "open_question": "Question ouverte",
        "review_available": "Tu peux maintenant vérifier ta réponse",
        "title": "Légende"
      },
      "next": "Exercice suivant",
      "previous": "Dernier exercice",
      "results": "résultats",
      "self_test": {
        "begin": "Commencer",
        "body": "Tu peux interrompre l’auto-test. Toutes les réponses enregistrées seront conservées.",
        "introduction": "Introduction",
        "next_self_score": "À l'exercice ouvert suivant",
        "result": "Résultat",
        "results": "Vers les résultats",
        "resume": "Continuer",
        "selfscore": {
          "multiple": "Attribue-toi une note pour plusieurs exercices en fonction d'une réponse modèle.",
          "single": "Attribue-toi une note pour un exercice en fonction d'une réponse modèle."
        },
        "submit": "Soumettre",
        "submit_text": "Tu as terminé tous les exercices. Soumets pour vérifier tes réponses."
      },
      "tooltip_self_score": "Exercice d'auto-évaluation"
    },
    "block": {
      "exercises": "Exercices",
      "score": "Résultat"
    },
    "overview": {
      "button": {
        "continue": "Continuer",
        "results": "Regarde",
        "show": {
          "results": "Voir les résultats"
        },
        "start": "Commencer"
      },
      "label": {
        "start": "Commence avec ton matériel de cours"
      }
    },
    "references": "Références",
    "tab": {
      "assignments": "Exercices",
      "contents": "Matériel de cours",
      "exercises": "Exercices",
      "learning_goals": "Objectifs d'apprentissage",
      "sources": "Sources",
      "terms": "Notions",
      "theory": "Théorie"
    }
  },
  "assignment": {
    "action": {
      "correct": "Bien fait ! Cette réponse est correcte.",
      "incorrect": "Ce n'est pas la bonne réponse.",
      "missed": "Cette réponse est bonne, mais tu ne l'as pas choisie.",
      "predefined": "Cette réponse a déjà été remplie pour toi et est correcte."
    },
    "actions": {
      "close": "Fermer",
      "primary": {
        "check": "Vérifier",
        "complete": "Exercice terminé",
        "save": "Sauvegarder",
        "save_edited": "Enregistrer la réponse modifiée",
        "submit": "Soumettre"
      }
    },
    "feedback": {
      "deleted_result": "Ton professeur a effacé la réponse pour que tu puisses refaire l'exercice.",
      "deleted_sequence_result": "Ton professeur a effacé les réponses de l’auto-test pour que tu puisses refaire les exercices.",
      "reset_score": "Ton professeur a effacé la réponse pour que tu puisses refaire l'exercice.",
      "teacher_message": "Message de ton professeur"
    },
    "loading": "L'exercice est en cours de chargement...",
    "question": {
      "result": {
        "actions": {
          "check_results": "Voir les résultats",
          "hide_answer": "Masquer la réponse",
          "next_question": "Exercice suivant",
          "show_answer": "Afficher la réponse"
        },
        "check_results": "Tu peux maintenant voir les résultats.",
        "info": {
          "hide_answer": "Masque la réponse pour pouvoir faire l'exercice."
        },
        "next_question": "Passe à l'exercice suivant.",
        "primary": {
          "check": "Complète l'exercice ci-dessus. Une fois terminé, tu peux vérifier ta réponse.",
          "complete": "Réalise l'exercice ci-dessus. Tu peux terminer une fois que tu as fait l'exercice.",
          "submit": "Complète l'exercice ci-dessus. Tu peux soumettre ta réponse quand tu as terminé."
        },
        "review_disabled": "La révision de ta réponse a été désactivée. Si tu veux t'évaluer, demande à ton professeur de réactiver la révision.",
        "self_score": {
          "actions": {
            "confirm_score": "Confirmer le score"
          },
          "check_answer_and_score": "Bien joué ! Vérifie ta réponse et attribue-toi une note ci-dessus.",
          "confirm_score": "Bien joué, tu peux maintenant confirmer ton score."
        },
        "statuses": {
          "checked": {
            "actions": {
              "show_answer": "Afficher la réponse",
              "show_answer_info": "Tu n'arrives pas à trouver la solution ? Tu peux voir les bonnes réponses. Ta note actuelle de {{score}}% ne peut plus être améliorée.",
              "try_again": "Essaie encore",
              "try_again_info": "(1)[première tentative];(2)[deuxième tentative];(3)[troisième tentative];(4)[quatrième tentative];(5)[cinquième tentative];(6)[sixième tentative];(7)[septième tentative];(8)[huitième tentative];(9)[neuvième tentative];(10)[dixième tentative];(11-inf)[tentative {{count}}]"
            },
            "max_score": "Bien joué ! Tu as terminé cet exercice.",
            "try_again": "Hmm, ta réponse n'était pas tout à fait correcte. Essaie encore."
          },
          "completed": {
            "attempt": "(1)[Score après la première tentative];(2)[Score après la deuxième tentative];(3)[Score après la troisième tentative];(4)[Score après la quatrième tentative];(5)[Score après la cinquième tentative];(6)[Score après la sixième tentative];(7)[Score après la septième tentative];(8)[Score après la huitième tentative];(9)[Score après la neuvième tentative];(10)[Score après la dixième tentative];(11-inf)[Score après la tentative {{count}}]",
            "default_one": "Ton score pour cet exercice est de {{score}}% après {{count}} tentative.",
            "default_other": "Ton score pour cet exercice est de {{score}}% après {{count}} tentatives.",
            "default_zero": "Ton score pour cet exercice est de {{score}}% après {{count}} tentatives.",
            "done": "Tu as terminé cet exercice.",
            "message": "Bien joué ! Tu as terminé cet exercice.",
            "message_closed": "Réponse affichée",
            "score": "résultat",
            "self_score": "Ton score pour cet exercice est de {{score}}%."
          },
          "submitted": {
            "actions": {
              "duplicate_value": "Cette réponse est la même qu'une réponse déjà donnée.",
              "try_again_info": "La réponse est enregistrée. Tu peux encore modifier ta réponse."
            }
          }
        },
        "validation": {
          "invalid": "Ta réponse n'est pas encore entièrement correcte.",
          "max": "Tu as dépassé le nombre maximum de réponses."
        }
      },
      "validation": {
        "max": "Tu as sélectionné trop de réponses."
      }
    },
    "results": {
      "average_score_no_scores": "Tu as fait des exercices pour lesquels tu ne recevras pas de note.",
      "average_score_text": "Jusqu'à présent, tu as une note moyenne de {{score}} sur les exercices réalisés.",
      "average_score_title": "Score moyen",
      "average_score_title_selftest": "Score : {{score}}",
      "average_score_title_with_score": "Score moyen : {{score}}",
      "back": "Regarde toutes tes exercises",
      "legenda": {
        "open_assignment": "Question ouverte",
        "title": "Légende:"
      },
      "loading": "Les résultats sont en cours de chargement...",
      "progress_text": "Tu as fait {{count}} sur {{total}} exercices.",
      "progress_title": "Tes progrès",
      "progress": {
        "completed": "Tu as terminé ce bloc d'exercices avec un score de",
        "completed_no_score": "Tu as terminé ce bloc d'exercices.",
        "incomplete": "Tu n'as pas encore terminé toutes les tâches."
      },
      "questions_title": "Résultat par exercice",
      "questions": {
        "done": "Les exercices sont triés par score. Tu peux revoir les exercices avec les scores les plus bas.",
        "todo": "Réponds aux questions suivantes pour terminer le bloc d'exercices."
      },
      "test_ended": "Soumis le {{date}} à {{time}}.",
      "test_started": "Commencé le {{date}} à {{time}} heures.",
      "title": "Résultats",
      "title_selftest": "Résultats : Auto-test"
    },
    "score": {
      "message": {
        "excellent": "Super travail, continue comme ça !",
        "marginal": "Tu es sur la bonne voie. Entraîne-toi encore un peu !",
        "poor": "Pas grave ! Apprends des retours et réessaie.",
        "satisfactory": "Bien joué ! C'est un très bon score.",
        "unsatisfactory": "Tu peux faire mieux ! Entraîne-toi encore un peu."
      }
    },
    "sidebar": {
      "back": "Aperçu des exercices",
      "back-to-theory": "À la théorie",
      "nav": {
        "introduction": "Introduction",
        "results": "Résultats"
      },
      "navigation": {
        "aria-label": {
          "close": "Fermer Table des matières",
          "collapse": "Réduire Table des matières",
          "expand": "Développer Table des matières",
          "open": "Ouvrir Table des matières"
        }
      },
      "secondary": {
        "nav": {
          "sources": "Références",
          "terms": "Notions",
          "theory": "Théorie"
        }
      },
      "tools": {
        "aria-label": {
          "close": "Fermer la théorie",
          "material": "{{ material }} s'ouvre dans une nouvelle fenêtre.",
          "open": "Ouvre la théorie"
        }
      }
    },
    "status": {
      "answered": "La réponse a été soumise",
      "checkingAvailable": "Tu peux maintenant vérifier ta réponse",
      "default": "Pas encore fait",
      "disabled": "Disponible après le début de l’auto-test",
      "done": "La réponse a été corrigée",
      "draft": "La réponse n’a pas encore été soumise"
    },
    "theory": {
      "alert": {
        "no_assignment_theory_found": "Il n'y a pas de théorie disponible pour ces exercices."
      },
      "close-theory": "Fermer la théorie"
    }
  },
  "button": {
    "adjust": "Modifier",
    "cancel": "Annuler",
    "delete": "Retirer",
    "save": "Sauvegarder"
  },
  "common": {
    "back_to_top": "Retour en haut",
    "next": "Suivant",
    "table_of_contents": "Table des matières"
  },
  "content": {
    "breadcrumbs": {
      "index": "Table des matières"
    },
    "figure": {
      "fallback-label": "Source {{addition}}"
    },
    "frame": {
      "label": {
        "case": "Cas",
        "context": "Contexte",
        "dialogue": "Dialogue",
        "example": "Exemple",
        "explanation": "Explication",
        "summary": "Résumé"
      }
    },
    "interactions": {
      "drawing_canvas": {
        "actions": {
          "clear": "Tout effacer"
        }
      },
      "model_answer": "Réponse modèle",
      "self_score": {
        "open_text": {
          "title": "Vérifie ta réponse :"
        },
        "rubric_group": {
          "weight": "Détermine {{weight}}% du score total."
        },
        "rubric": {
          "completed": "C'est le score total que tu t'es attribué pour cet exercice.",
          "explanation": "Le score est composé des éléments suivants :",
          "next_group": "Évaluation suivante",
          "prev_group": "Évaluation précédente",
          "title": "Vérifie toi-même ta réponse et choisis un score approprié :"
        },
        "scale": {
          "explanation": "C'est le score que tu as attribué à ta réponse soumise :",
          "title": "À quel point ta réponse est-elle correcte ?"
        }
      },
      "speaking": {
        "action_listen": {
          "label": "Écouter"
        },
        "action_play": {
          "instruction": "Enregistrement",
          "label": "Lire"
        },
        "action_record": {
          "instruction": "Maintenir enfoncé",
          "label": "Enregistrer"
        },
        "score": {
          "excellent": "Bien joué !",
          "poor": "Cela peut être mieux. Écoute encore attentivement les mots avec un soulignement en dessous.",
          "satisfactory": "Presque bon, essaie encore !",
          "unsatisfactory": "Bonne tentative, mais cela peut être mieux. Écoute encore attentivement les mots avec un soulignement en dessous."
        }
      },
      "upload": {
        "drop_dragging_file": "Déposez votre image pour la télécharger",
        "drop_file": "Télécharger une image",
        "dropped_file": "Votre fichier a été téléchargé !",
        "placeholder": "Glissez une image ici ou sélectionnez une image",
        "select_file": "Sélectionner l'image",
        "uploading": "Téléchargement de l'image..."
      },
      "validators": {
        "max": "Tu as dépassé le nombre maximum de réponses.",
        "min": "La valeur minimale est {{min}}",
        "must-contain": "Votre réponse doit contenir '{{mustContain}}'",
        "required": "Vous devez fournir une réponse"
      },
      "your_answer": "Ta réponse"
    },
    "quote": {
      "author": {
        "title": "Auteur de la citation"
      }
    },
    "remark": {
      "label": {
        "attention": "Attention !",
        "hint": "Indice",
        "tip": "Tuyau"
      }
    },
    "score-label": {
      "completed": "Exercice terminé"
    }
  },
  "label": {
    "theory": "Théorie"
  },
  "landing": {
    "main": {
      "label_all_arrangements": "Tous les matériels pédagogiques",
      "label_continue": "Continuer",
      "label_user_defined_arrangements": "Matériels pédagogiques préparés par ton professeur"
    },
    "view_all": "Tous les matériels pédagogiques"
  },
  "teacher-material": {
    "articles": {
      "learning_time_indicator": "{{ amount }} minutes"
    }
  }
}
